<template>
  <sdv-dialog v-model="open" width="500" @close="closeDialog">
    <template #header>
      <p class="modal-card-title">
        Billing Info
      </p>
    </template>
    <div class="notification is-info" role="alert">
      <p>
        <strong>Whoops!</strong>
        It seems we don't have a valid payment method for you on file.
        Please update your payment information to continue.
      </p>
    </div>
    <payment-form @updated="$emit('updated')" />
  </sdv-dialog>
</template>
<script>
export default {
  components: {
    SdvDialog: () => import('@/components/shared/SdvDialog.vue'),
    PaymentForm: () => import('@/components/profile/PaymentForm.vue')
  },
  name: 'PaymentFormDialog',
  model: {
    prop: 'open',
    event: 'close'
  },
  props: {
    open: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    // Computed fields
  },
  methods: {
     closeDialog() {
      // Other functionality
      this.$emit('close');
    }
  }
};
</script>
<style lang="scss" scoped></style>
